import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { productListLineStyles } from "@dana/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GridOffset } from "@insite/mobius/GridContainer/GridContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

productListLineStyles.productBrandStyles = mergeToNew(productListLineStyles.productBrandStyles, {
    nameText: {
        weight: fontWeights.semiBold,
    },
});

productListLineStyles.productPriceStyles = mergeToNew(productListLineStyles.productPriceStyles, {
    priceLabelText: {
        transform: "capitalize",
        color: themeBackgrounds.darkGray,
    },
});

productListLineStyles.productImageStyles = mergeToNew(productListLineStyles.productImageStyles, {
    linkWrappingImage: {
        css: css`
            margin-bottom: 4px;
        `,
    },
});

productListLineStyles.addToCartButton = mergeToNew(productListLineStyles.addToCartButton, {
    messageStyles: {
        css: css`
            .info-message-box {
                display: block;
                font-size: ${fontSizes.small};
            }
        `,
    },
    button: {
        css: css`
            min-width: 150px;
        `
    },
    messageStylesWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        &,
                        button {
                            width: 100%;
                        }
                    `,
                ],
                "min",
            )}
        `
    }
});

productListLineStyles.buttonsGridItem = mergeToNew(productListLineStyles.buttonsGridItem, {
    printWidth: 0,
    css: css`
        .info-message-box {
            text-align: left;
        }

        @media print {
            display: none !important;
        }
    `,
});

productListLineStyles.priceGridItem = mergeToNew(productListLineStyles.priceGridItem, {
    width: [12, 12, 12, 6, 6],
});

productListLineStyles.uomAndQuantityGridItem = mergeToNew(productListLineStyles.uomAndQuantityGridItem, {
    width: [12, 12, 12, 6, 6],
});

productListLineStyles.quantityGridItem = mergeToNew(productListLineStyles.quantityGridItem, {
    width: [9, 9, 12, 12, 12],
    css: css`
        flex-direction: column;
    `
});

productListLineStyles.overflowMenuGridItem = mergeToNew(productListLineStyles.overflowMenuGridItem, {
    css: css`
        button,
        button:is(:hover, :focus, :focus-visible, :active) {
            background-color: transparent;
        }

        @media print {
            display: none !important;
        }
    `,
});

productListLineStyles.productQuantityOrderedStyles = mergeToNew(productListLineStyles.productQuantityOrderedStyles, {
    cssOverrides: {
        formField: css`
            [data-test-selector="product_qtyOrdered-label"] {
                font-size: ${fontSizes.medium};
                line-height: ${lineHeights.medium};
                color: ${themeBackgrounds.darkGray};
            }

            @media print {
                input[type="number"]::-webkit-inner-spin-button,
                input[type="number"]::-webkit-outer-spin-button {
                    opacity: 0;
                }

                input:not(.react-datetime-picker__inputGroup__input) {
                    border: none;
                    background: none;
                    padding: 0;
                }
            }
        `,
    },
});



productListLineStyles.notesGridItem = mergeToNew(productListLineStyles.notesGridItem, {
    css: css`
        padding: 0;
    `,
});

productListLineStyles.notesStyles = mergeToNew(productListLineStyles.notesStyles, {
    wrapper: {
        css: css`
            margin-top: 16px;

            @media print {
                margin-top: 0;
            }
        `,
    },
    heading: {
        size: fontSizes.medium,
        lineHeight: lineHeights.medium,
        transform: "capitalize",
        css: css`
            margin-bottom: 8px;
        `,
    },
});

productListLineStyles.deleteButton =  mergeToNew(productListLineStyles.deleteButton, {
    variant: "primary",
    css: css`
        margin-top: 10px;
        min-width: 150px;
        ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(
            theme,
            [
                null,
                null,
                null,
                css`
                    width: 100%;
                `,
            ],
            "min",
        )}
    `
});


productListLineStyles.lineInnerContainer = mergeToNew(productListLineStyles.lineInnerContainer, {
    css: css`
        > ${GridOffset} {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            .imageTopWrapper {
                padding-left: 0;
            }
        }
       
    `
})

productListLineStyles.descriptionGridItem = mergeToNew(productListLineStyles.descriptionGridItem, {
    width: [8, 8, 6, 6, 7],
    css: css`   
        @media print {
            [class*="HiddenStyle"] > [class*="GridItemStyle"] {
                padding-left: 0;
            }
        }
    `
});

productListLineStyles.priceAndAvailabilityGridItem = mergeToNew(productListLineStyles.priceAndAvailabilityGridItem, {
    width: [12, 12, 2, 2, 2],
});

productListLineStyles.productPartNumbersStyles = mergeToNew(productListLineStyles.productPartNumbersStyles, {
   container: {
        css: css`
            @media print {
                > div {
                    margin-left: 0;    
                    >  div {
                        padding-left: 0; 
                    }
                }
            }
        `
   }, 
});

productListLineStyles.imageWrapper = mergeToNew(productListLineStyles.imageWrapper, {
    css: css`
        @media print {
            max-width: 75px;
            max-height: initial;
            img {
                max-height: 50px;
                width: auto;
            }
            a {
                justify-content: center;
            }
        }
    `
});